import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  constructionSelector,
  (construction) => ({
    available: [...construction.available.additional_closing_remote],
    info: construction.info.additional_closing_remote,
    loaded: construction.parameters_loaded,
    selected: construction.selected.additional_closing_remote
  })
);
